var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styled from 'styled-components';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const LinkSC = styled.a `
  user-select: none;

  font-family: ${(props) => props.theme.FontFamilyBase};
  font-weight: bold;
  color: ${(p) => p.mode === 'dark' ? p.theme.ColorFontLinkDarkMode : p.theme.ColorFontLinkBase};

  will-change: mode, box-shadow;
  transition: mode, 0.3s, box-shadow 0.3s;

  text-decoration: none;

  :link,
  :visited {
    text-decoration: none;
    color: ${(p) => p.mode === 'dark'
    ? p.theme.ColorFontLinkVisitedDarkMode
    : p.theme.ColorFontLinkVisited};
  }

  :focus,
  :hover {
    cursor: pointer;
    box-shadow: 0 0.0625rem
      ${(p) => p.mode === 'dark'
    ? p.theme.ColorUnderlineLinkHoverDarkMode
    : p.theme.ColorUnderlineLinkHover};
  }

  :active {
    color: ${(p) => p.mode === 'dark'
    ? p.theme.ColorFontLinkActiveDarkMode
    : p.theme.ColorFontLinkActive};
    box-shadow: 0 0.0625rem
      ${(p) => p.mode === 'dark'
    ? p.theme.ColorUnderlineLinkActiveDarkMode
    : p.theme.ColorUnderlineLinkActive};
  }

  &._ndsLink--small {
    font-size: ${(props) => props.theme.SizeFontLinkSmall};
    line-height: ${(props) => props.theme.SizeLineHeightLinkSmall};
  }

  &._ndsLink--medium {
    font-size: ${(props) => props.theme.SizeFontLinkMedium};
    line-height: ${(props) => props.theme.SizeLineHeightLinkMedium};
  }

  &._ndsLink--large {
    font-size: ${(props) => props.theme.SizeFontLinkLarge};
    line-height: ${(props) => props.theme.SizeLineHeightLinkLarge};
  }

  &._ndsLink--disabled {
    pointer-events: none;
    color: ${(p) => p.mode === 'dark'
    ? p.theme.ColorFontLinkDisabledDarkMode
    : p.theme.ColorFontLinkDisabled};
  }
`;
const Link = (props) => {
    const { children, size, mode, disabled, forwardedRef, className: classNameProp } = props, others = __rest(props, ["children", "size", "mode", "disabled", "forwardedRef", "className"]);
    const classNames = clsx(classNameProp, { '_ndsLink--small': size === 's' }, { '_ndsLink--medium': size === 'm' }, { '_ndsLink--large': size === 'l' }, { '_ndsLink--disabled': disabled });
    return (React.createElement(LinkSC, Object.assign({ ref: forwardedRef, mode: mode, className: classNames }, others), children));
};
Link.propTypes = {
    size: PropTypes.oneOf(['s', 'm', 'l']),
    mode: PropTypes.oneOf(['dark', 'light']),
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    forwardedRef: PropTypes.any,
    className: PropTypes.string
};
Link.defaultProps = {
    size: 'm',
    mode: 'light',
    disabled: false,
    children: null,
    forwardedRef: null,
    className: null
};
export { Link as LinkRootComp };
export default withForwardedRef(Link);
//# sourceMappingURL=Link.js.map